module.exports = __webpack_public_path__ + "img/shopping-bag-1.78eafb77.svg";